// ==========================================================================
// SLIDER — Swiper init for home page
// ==========================================================================

import Swiper from 'swiper';
import { Keyboard, Mousewheel } from 'swiper/modules';

const ARROW_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.31 42.86" aria-hidden="true"><polyline points="20.44 .44 41.42 21.43 20.44 42.42" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.25"/><line x1="0" y1="21.43" x2="41.42" y2="21.43" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.25"/></svg>`;

function initCustomCursor(sliderEl) {
  if (!sliderEl || window.matchMedia('(hover: none)').matches) return;

  const homeNav = document.getElementById('home-nav');

  const cursor = document.createElement('div');
  cursor.className = 'slider-cursor';
  cursor.innerHTML = ARROW_SVG;
  document.body.appendChild(cursor);

  let pendingX = 0, pendingY = 0, rafId = null;

  function moveCursor() {
    cursor.style.left = pendingX + 'px';
    cursor.style.top  = pendingY + 'px';
    rafId = null;
  }

  document.addEventListener('mousemove', (e) => {
    pendingX = e.clientX;
    pendingY = e.clientY;
    if (!rafId) rafId = requestAnimationFrame(moveCursor);

    const rect      = sliderEl.getBoundingClientRect();
    const inSlider  = e.clientX >= rect.left && e.clientX <= rect.right &&
                      e.clientY >= rect.top  && e.clientY <= rect.bottom;
    const overNav   = homeNav?.contains(e.target) ?? false;

    if (inSlider && !overNav) {
      cursor.classList.add('is-active');
      sliderEl.classList.add('cursor-hidden');
      cursor.classList.toggle('is-prev', e.clientX - rect.left < rect.width * 0.2);
    } else {
      cursor.classList.remove('is-active', 'is-prev');
      sliderEl.classList.remove('cursor-hidden');
    }
  });
}

export function initSlider() {
  const counterEl   = document.querySelector('.slide__counter');
  const totalSlides = document.querySelectorAll('.swiper-slide').length;
  const sliderEl    = document.querySelector('.home-slider');

  const swiper = new Swiper('.home-slider', {
    modules: [Keyboard, Mousewheel],
    direction: 'horizontal',
    loop: true,
    simulateTouch: false,
    keyboard: {
      enabled: true,
    },
    mousewheel: {
      enabled: true,
      sensitivity: 1,
      thresholdDelta: 40,
      thresholdTime: 500,
    },
    on: {
      slideChange(swiper) {
        if (counterEl) {
          counterEl.textContent = `${swiper.realIndex + 1} | ${totalSlides}`;
        }
      },
    },
  });

  // Click: slidePrev in left 20%, slideNext otherwise — links are excluded
  sliderEl?.addEventListener('click', (e) => {
    if (e.target.closest('a')) return;
    const rect = sliderEl.getBoundingClientRect();
    e.clientX - rect.left < rect.width * 0.2 ? swiper.slidePrev() : swiper.slideNext();
  });

  if (counterEl) {
    counterEl.textContent = `1 | ${totalSlides}`;
  }

  initCustomCursor(sliderEl);

  return swiper;
}
